import React from 'react';

function HeadDesktop({ workflow }) {
  return (
    <div className="auth-section">
      <div className="signup-container">
        <div className="signup-text">
          <h1>Make Scroll Stopping Videos in 5 Minutes</h1>
          <p className="auth-intro">Make Gorgeous Videos Today</p>
        </div>
        <div className="signin-section">
          <div className="signin-header">
            <button
            // onClick="toggleSignup(false)"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="32"
                height="32"
                viewBox="0 0 24 24"
              >
                <path
                  fill="currentColor"
                  d="M15.45 17.97L9.5 12.01a.25.25 0 0 1 0-.36l5.87-5.87a.75.75 0 0 0-1.06-1.06l-5.87 5.87c-.69.68-.69 1.8 0 2.48l5.96 5.96a.75.75 0 0 0 1.06-1.06z"
                />
              </svg>
            </button>
            <h3>Log in to your account</h3>
          </div>
          <div
            aria-hidden
            className="signup-btn google"
            // onClick="doGoogleLogin()"
          >
            <div className="logo">
              <img
                src="https://d1nc6vzg2bevln.cloudfront.net/images/wp-assets/google-logo.svg"
                alt="Google Logo"
              />
            </div>
            <div className="btn-text">Continue with Google</div>
          </div>
          <div
            aria-hidden
            className="signup-btn fb"
            // onClick="doFacebookLogin()"
          >
            <div className="logo">
              <i className="fab fa-facebook-square" />
            </div>
            <div className="btn-text">Continue with Facebook</div>
          </div>
          <div className="divider-section">
            <hr />
            <span>OR</span>
            <hr />
          </div>
          <form
            name="sign-in-form-direct"
            id="sign-in-form-direct"
            method="post"
            className="form"
            noValidate="novalidate"
          >
            <div className="form-group">
              <input
                type="text"
                className="signup-input"
                placeholder="Email"
                name="signin_email"
                id="signin-email"
              />
            </div>
            <div className="form-group">
              <input
                type="password"
                className="signup-input"
                placeholder="Password"
                name="signin_password"
                id="signin-pwd"
              />
            </div>
            <span className="signin-global-error signup-err" />
            <div className="direct-signin-btn email" id="email-signup-btn">
              <button
                type="submit"
                id="submit-button-signin"
                className="btn-text direct-signin-btn"
              >
                Log In
              </button>
            </div>
          </form>
        </div>
        <div className="signin-text">
          <button
            type="submit"
            id="submit-button-signin"
            className="btn-text direct-signin-btn bg-brandPrimary text-white px-6 py-4 w-full rounded my-2"
            onClick={() => workflow('/workflow/marketing-templates/', 'center')}
          >
            Create Free Account
          </button>
          <p className="already-member">
            Already signed up?{' '}
            <button
              onClick={() =>
                workflow('/workflow/marketing-templates/', 'center')
              }
              id="direct-signin"
              href=""
              className="login-text login"
            >
              Log in
            </button>
          </p>
        </div>
      </div>
      <div className="info-section">
        <div className="client">
          <a
            rel="noreferrer"
            href="https://www.capterra.com/p/180680/InVideo/"
            target="_blank"
          >
            <span className="company-logo">
              <picture>
                <source
                  type="image/webp"
                  srcSet="https://d360zdw5tkn3j9.cloudfront.net/Template_Block_Assets/landing-page/Image_93.webp"
                />
                <source
                  type="image/png"
                  srcSet="https://d360zdw5tkn3j9.cloudfront.net/Template_Block_Assets/landing-page/Image_93.png"
                />
                <img
                  className="z-depth-1 capterra-sprite"
                  loading="lazy"
                  src="https://d360zdw5tkn3j9.cloudfront.net/Template_Block_Assets/landing-page/Image_93.png"
                  alt="InVideo Captera reviews"
                />
              </picture>
            </span>
            <span className="company-stars">
              <picture>
                <source
                  type="image/png"
                  srcSet="https://d360zdw5tkn3j9.cloudfront.net/Template_Block_Assets/landing-page/star-blues.png"
                />
                <img
                  className="z-depth-1 rating"
                  loading="lazy"
                  src="https://d360zdw5tkn3j9.cloudfront.net/Template_Block_Assets/landing-page/star-blues.png"
                  alt="InVideo Captera ratings"
                />
              </picture>
            </span>
          </a>
        </div>
        <div className="client">
          <a
            rel="noreferrer"
            href="https://www.g2.com/products/invideo/reviews"
            target="_blank"
          >
            <span className="company-logo">
              <picture>
                <source
                  type="image/webp"
                  srcSet="https://d360zdw5tkn3j9.cloudfront.net/Template_Block_Assets/landing-page/Image_134.webp"
                />
                <source
                  type="image/png"
                  srcSet="https://d360zdw5tkn3j9.cloudfront.net/Template_Block_Assets/landing-page/Image_134.png"
                />
                <img
                  className="z-depth-1 g2-sprite"
                  loading="lazy"
                  src="https://d360zdw5tkn3j9.cloudfront.net/Template_Block_Assets/landing-page/Image_134.png"
                  alt="InVideo G2 Crowd reviews"
                />
              </picture>
            </span>
            <span className="company-stars">
              <picture>
                <source
                  type="image/png"
                  srcSet="https://d360zdw5tkn3j9.cloudfront.net/Template_Block_Assets/landing-page/star-blues.png"
                />
                <img
                  className="z-depth-1 rating"
                  loading="lazy"
                  src="https://d360zdw5tkn3j9.cloudfront.net/Template_Block_Assets/landing-page/star-blues.png"
                  alt="InVideo G2 ratings"
                />
              </picture>
            </span>
          </a>
        </div>
        <div className="score-wrapper">
          <p className="label">Total videos created</p>
          <div className="counter-wrapper">
            <span className="value" id="counter">
              57558
            </span>
            <span className="value" id="counter2" />
          </div>
        </div>
      </div>
    </div>
  );
}

export default HeadDesktop;
